import { Autocomplete, Box, TextField } from '@mui/material';
import type { Country } from 'countries-list';
import { countries } from 'countries-list';
import React from 'react';

type CountrySelectProps = {
  value?: Country | null;
  onChange?: (country: Country | null) => void;
  textFieldProps?: React.ComponentProps<typeof TextField>;
  disabled?: boolean;
};

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  textFieldProps,
  disabled,
}) => {
  return (
    <Autocomplete
      fullWidth
      autoHighlight
      getOptionLabel={(option) => option.name}
      size="small"
      options={Object.values(countries)}
      disabled={disabled}
      renderOption={({ key, ...optionProps }, option) => (
        <Box key={key} component="li" sx={{ columnGap: '20px', display: 'flex' }} {...optionProps}>
          {`${option.emoji} ${option.name}`}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            }
          }}
        />
      )}
      value={value}
      onChange={(_event, newValue) => {
        _event.preventDefault();
        onChange?.(newValue);
      }}
    />
  );
};
